module.exports = __webpack_public_path__ + "static/media/ModelBuilderLogo.46697d32.svg";